module.exports = __webpack_public_path__ + "static/media/officemax-grand-and-toy.9c27acd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/officemax-grand-and-toy.jpg
// module id = 1320
// module chunks = 0